// extracted by mini-css-extract-plugin
export default {"link":"linkButton-module__link__w8+BO","button":"linkButton-module__button__krSiC"};